import {
  DISTRIBUTION_CURVES_OPTIONS as distributionCurvesOptions,
  TRANSFORMATION_OPTIONS as transformationOptions,
} from "../../../../constants/visualizationOptions";
import React from "react";
import {
  Card,
  CardContent,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Box,
  Grid,
  TextField,
  Button,
  Checkbox,
  Chip,
  OutlinedInput,
  Switch,
  FormControlLabel,
  Tooltip,
  IconButton,
} from "@mui/material";
import Label from "../../../../components/Label/Label";
import "./PPChartConfigs.scss";

import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";

const PPChartConfigs = ({
  unitOfOperationId,
  updateState,
  handleGenerate,
  configState,
  onClickClearCurrentConfig,
  disableAllFields,
  setShowConfigPanel,
  setSelectedTab,
}) => {
  const handleCurveChange = (selected) => {
    const wasJohnsonSelected =
      configState.selectedCurves?.includes("johnsonsb");
    const isJohnsonSelectedNow = selected.includes("johnsonsb");
    if (wasJohnsonSelected && !isJohnsonSelectedNow) {
      updateState("johnson_sb_lower_bound", "");
      updateState("johnson_sb_upper_bound", "");
    }

    updateState("selectedCurves", selected);
  };

  const handleChange = (event) => {
    // Exclude "none" from being deselected
    const value = event.target.value.filter((v) => v !== "none");
    updateState("transformation", ["none", ...value]);
  };

  return (
    <Box className="plot-config-wrapper">
      <Box className="scrollable-config">
        {/* QQ Curves */}
        <Card elevation={0} className="filter-card plot-config-card">
          <CardContent className="toggle-section">
            <Box>
              <Label text="Add Distribution Curves" fontWeight="500" />

              <FormControl
                fullWidth
                size="small"
                className="dropdown-field"
                sx={{ mt: 1 }}
                disabled={disableAllFields}
              >
                <InputLabel>Select Curves</InputLabel>
                <Select
                  multiple
                  value={
                    Array.isArray(configState.selectedCurves)
                      ? configState.selectedCurves
                      : typeof configState.selectedCurves === "string"
                        ? configState.selectedCurves.split(",")
                        : []
                  }
                  onChange={(e) => {
                    const selected = e.target.value;

                    // Ensure "norm" stays in the selected list
                    if (!selected.includes("norm")) {
                      selected.push("norm");
                    }

                    handleCurveChange(selected);
                  }}
                  label="Select Curves"
                  renderValue={(selected) => (
                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                      {selected?.map((value) => {
                        const label = distributionCurvesOptions?.find(
                          (option) => option.value === value,
                        )?.label;

                        const isLocked = value === "norm";

                        return (
                          <Chip
                            key={value}
                            label={label || value}
                            size="small"
                            // onDelete={
                            //   !isLocked
                            //     ? (event) => {
                            //         event.preventDefault(); // ✅ stops default behavior
                            //         event.stopPropagation(); // ✅ stops propagation to Select
                            //         const updated = selected.filter(
                            //           (val) => val !== value
                            //         );
                            //         updateState("selectedCurves", updated);
                            //       }
                            //     : undefined
                            // }
                            style={
                              isLocked
                                ? {
                                    backgroundColor: "#e0e0e0",
                                    fontWeight: 500,
                                  }
                                : {}
                            }
                          />
                        );
                      })}
                    </Box>
                  )}
                >
                  {distributionCurvesOptions.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      <Box display="flex" alignItems="center">
                        <Checkbox
                          checked={configState.selectedCurves?.includes(
                            option.value,
                          )}
                          disableRipple
                          style={{ padding: 0, marginRight: 8 }}
                          disabled={option.value === "norm"}
                        />
                        {option.label}
                      </Box>
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
            <Card elevation={0} className="filter-card plot-config-card">
              <CardContent className="toggle-section">
                <FormControlLabel
                  sx={{ pl: "8px", pr: "8px" }}
                  control={
                    <Switch
                      checked={configState.show_grid}
                      onChange={(e) =>
                        updateState("show_grid", e.target.checked)
                      }
                    />
                  }
                  label={<Label text="Show Grid" fontWeight="500" />}
                  disabled={disableAllFields}
                />
              </CardContent>
            </Card>
            {/* {configState.selectedCurves?.includes("johnsonsb") && (
              <Box sx={{ mt: 1 }}>
                <Label text="Johnson Sb" fontWeight="500" />
                <Grid container spacing={2} pt={1}>
                  <Grid item xs={6}>
                    <TextField
                      type="number"
                      label="Lower Bound"
                      size="small"
                      fullWidth
                      value={configState.johnson_sb_lower_bound}
                      onChange={(e) =>
                        updateState("johnson_sb_lower_bound", e.target.value)
                      }
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      type="number"
                      label="Upper Bound"
                      size="small"
                      fullWidth
                      value={configState.johnson_sb_upper_bound}
                      onChange={(e) =>
                        updateState("johnson_sb_upper_bound", e.target.value)
                      }
                    />
                  </Grid>
                </Grid>
              </Box>
            )} */}
          </CardContent>
        </Card>

        {/* Transformation */}
        {/* <Card elevation={0} className="filter-card plot-config-card">
          <CardContent className="toggle-section">
            <Label text="Apply Transformation" fontWeight="500" />
            <FormControl
              fullWidth
              size="small"
              className="dropdown-field"
              sx={{ mt: 1 }}
            >
              <InputLabel>Select Transformation</InputLabel>
              <Select
                value={configState.transformation || ""}
                onChange={(e) => updateState("transformation", e.target.value)}
                label="Select Transformation"
              >
                <MenuItem value="">
                  <em>None</em>
                </MenuItem>
                {transformationOptions.map((transform) => (
                  <MenuItem key={transform.value} value={transform.value}>
                    {transform.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </CardContent>
        </Card> */}

        {/* <Card elevation={0} className="filter-card plot-config-card">
          <CardContent className="toggle-section">
            <Label text="Apply Transformation" fontWeight="500" />
            <FormControl
              fullWidth
              size="small"
              className="dropdown-field"
              sx={{ mt: 1 }}
            >
              <InputLabel>Select Transformation</InputLabel>
              <Select
                multiple
                value={configState.transformation}
                onChange={handleChange}
                input={<OutlinedInput label="Select Transformation" />}
                renderValue={(selected) =>
                  selected
                    .map(
                      (val) =>
                        transformationOptions?.find((t) => t.value === val)
                          ?.label
                    )
                    .join(", ")
                }
              >
                {transformationOptions.map((transform) => (
                  <MenuItem
                    key={transform.value}
                    value={transform.value}
                    disabled={transform.value === "none"} // Disable "none"
                  >
                    <Checkbox
                      checked={
                        configState.transformation.indexOf(transform.value) > -1
                      }
                    />
                    <Label text={transform.label} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl> */}

        {/* Show lambda input only when Johnson Sb is selected */}
        {/* {configState?.transformation.includes("johnson") && (
              <Box sx={{ mt: 2 }}>
                <TextField
                  type="number"
                  size="small"
                  label="Lambda"
                  value={configState.lambda}
                  onChange={(e) => updateState("lambda", e.target.value)}
                  fullWidth
                />
              </Box>
            )} */}
        {/* </CardContent>
        </Card> */}
      </Box>

      {/* Footer Buttons */}
      <Box className="plot-footer-sticky">
        <Card elevation={0} className="filter-card  plot-footer-btn-card">
          <CardContent>
            <Box display="flex" justifyContent="flex-end" gap={1}>
              <Tooltip title="Previous">
                <IconButton
                  onClick={() => setSelectedTab("batchFilters")}
                  size="small"
                  sx={{
                    backgroundColor: "primary.main",
                    color: "#fff",
                    "&:hover": {
                      backgroundColor: "primary.dark",
                    },
                    borderRadius: "8px",
                    px: 1,
                    py: 0.6,
                  }}
                >
                  <ArrowBackIosNewIcon fontSize="small" />
                </IconButton>
              </Tooltip>
              <Button
                variant="outlined"
                className="close-btn"
                onClick={() => setShowConfigPanel(false)}
              >
                Close
              </Button>
              <Button
                variant="outlined"
                onClick={onClickClearCurrentConfig}
                disabled={disableAllFields}
              >
                Clear Config
              </Button>
              <Button
                variant="contained"
                onClick={handleGenerate}
                disabled={!unitOfOperationId || disableAllFields}
              >
                Apply
              </Button>
            </Box>
          </CardContent>
        </Card>
      </Box>
    </Box>
  );
};

export default PPChartConfigs;
